import { classNames } from 'primereact/utils'

const inputText = {
    root: ({ props, context }: { props: any; context: any }) => {
        return {
            className: classNames(
                // Font
                'font-sans',
                'leading-[normal]',
                // Spacing
                'm-0 p-2.5',
                // Colors
                'text-allstate-navy',
                'placeholder:text-grey-8',
                'bg-white',
                'border border-solid',
                { 'border-grey-5': !props.invalid },
                // Invalid State
                'invalid:focus:ring-warning-red',
                'invalid:hover:border-warning-red',
                { 'border-warning-red': props.invalid },
                // States
                {
                    'select-none pointer-events-none cursor-default !bg-grey-2':
                        context.disabled,
                },
                // Misc
                'rounded-md',
                'appearance-none',
                'transition-colors duration-200',
            ),
        }
    },
}

export default inputText
